<template>
    <div>
        <NotificationsNhipSong v-if="theme != 'vtf2020'" :user="user"></NotificationsNhipSong>
        <VTF v-if="theme == 'vtf2020'" :user="user" :urlLogout="urllogout"></VTF>
    </div>
</template>
<script>
    import axios from 'axios';
    import InfiniteLoading from 'vue-infinite-loading';
    //components
    import NotificationsNhipSong from './NotificationsNhipSong.vue';
    import VTF from './NotificationVTF.vue';

    export default {
        props: [
            'theme',
            'urllogout'
        ],
        components: {
            InfiniteLoading,
            VTF,
            NotificationsNhipSong,
        },
        data() {
            return {}
        },
    }
</script>